module.exports = __webpack_public_path__ + "img/internet10.7fbf38ff.png";